import React from "react";
import { Button, Col, Row } from "reactstrap";

const Welcome = () => {
  return (
    <React.Fragment>
      <div className="chat-welcome-section">
        <Row className="w-100 justify-content-center">
          <Col xxl={5} md={7}>
            <div className="p-4 text-center">
              <div className="avatar-xl mx-auto mb-4">
                <div className="avatar-title bg-soft-primary rounded-circle">
                  <i className="bx bxs-message-alt-detail display-4 text-primary m-0"></i>
                </div>
              </div>
              <h4>Bem-vindo ao ZConnect App</h4>
              <p className="w-100 text-muted mb-4">
                Centralize conversas, agilize respostas e ofereça um atendimento mais eficiente. O ZConnect App conecta sua equipe ao cliente de forma inteligente.
              </p>
              <Button type="button" className="btn btn-primary w-lg">
                Comece agora
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Welcome;
